import * as styles from './styles.css';
import {
  Checkbox as MUICheckbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
} from '@mui/material';
import FormLabel from '@mui/material/FormLabel';

interface IAvailabilityDayState {
  morning: boolean;
  afternoon: boolean;
  evening: boolean;
}

export interface IAvailabilityDayProps {
  id?: string;
  day: string;
  required?: boolean;
  error?: string;
  state: IAvailabilityDayState;
  setState: (new_state: IAvailabilityDayState) => void;
}

const AvailabilityDay = ({ id, day, required, error, state, setState }: IAvailabilityDayProps) => {
  return (
    <FormControl
      id={id}
      className={styles.availability_day.container}
      required={required}
      error={!!error}
    >
      <FormLabel className={styles.availability_day.label}>{day}</FormLabel>
      <FormGroup className={styles.availability_day.options}>
        <FormControlLabel
          control={
            <MUICheckbox
              id={`${id}-morning`}
              checked={state.morning}
              onChange={() => setState({ ...state, morning: !state.morning })}
            />
          }
          label={'Morning'}
        />
        <FormControlLabel
          control={
            <MUICheckbox
              id={`${id}-afternoon`}
              checked={state.afternoon}
              onChange={() => setState({ ...state, afternoon: !state.afternoon })}
            />
          }
          label={'Afternoon'}
        />
        <FormControlLabel
          control={
            <MUICheckbox
              id={`${id}-evening`}
              checked={state.evening}
              onChange={() => setState({ ...state, evening: !state.evening })}
            />
          }
          label={'Evening'}
        />
      </FormGroup>
      {error && <FormHelperText id={`${id}-error`}>{error}</FormHelperText>}
    </FormControl>
  );
};

export default AvailabilityDay;
